import { render, staticRenderFns } from "./AssetsLinkViewOrEdit.vue?vue&type=template&id=5c00dacc&scoped=true"
import script from "./AssetsLinkViewOrEdit.vue?vue&type=script&lang=js"
export * from "./AssetsLinkViewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./AssetsLinkViewOrEdit.vue?vue&type=style&index=0&id=5c00dacc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c00dacc",
  null
  
)

export default component.exports